import React from "react";
import { Badge } from "tabler-react";
const possibleLicenses = ["INV", "CRM", "HRM", "KYC"];
const LicenseBadges = ({ licenses }) => {
  return (
    <React.Fragment>
      {possibleLicenses.map((license) => (
        <Badge
          color={licenses.includes(license) ? "success" : "secondary"}
          className="mr-1 badges "
        >
          {license}
        </Badge>
      ))}
    </React.Fragment>
  );
};

export default LicenseBadges;
